import { Chip } from "@heroui/react";
import { Calendar, Photos, Tag } from "assets/icons";
import { useEffect, useState } from "react";
import { FileLog } from "shared/types/file";

interface PhotoCardProps {
  photo: FileLog;
  incomingIsSelected?: boolean;
  onClick?: () => void;
}

export const PhotoCard: React.FC<PhotoCardProps> = ({
  photo,
  incomingIsSelected,
  onClick,
}) => {
  const [isSelected, setIsSelected] = useState(incomingIsSelected);
  // Thumbnail first (small & fast), full download URL as fallback.
  // photo.sharePointFileUrl is a SharePoint viewer page and can never render inside <img>.
  const [imageSrc, setImageSrc] = useState<string | undefined>(
    photo.thumbnailUrl || photo.imageUrl,
  );

  useEffect(() => {
    setImageSrc(photo.thumbnailUrl || photo.imageUrl);
  }, [photo.thumbnailUrl, photo.imageUrl]);

  useEffect(() => {
    setIsSelected(incomingIsSelected);
  }, [incomingIsSelected]);

  const handleImageError = () => {
    if (imageSrc && photo.imageUrl && imageSrc !== photo.imageUrl) {
      setImageSrc(photo.imageUrl);
    } else {
      setImageSrc(undefined);
    }
  };

  return (
    <div
      className={`flex max-w-[180px] transform cursor-pointer flex-col gap-2 p-2 transition duration-300 ease-in-out hover:opacity-60 ${isSelected ? "rounded-lg ring-2 ring-inset ring-brick-primary" : ""}`}
      onClick={onClick}
    >
      {imageSrc ? (
        <img
          src={imageSrc}
          alt={photo.fileLabel?.toString()}
          onError={handleImageError}
          className="h-40 w-full rounded-md object-cover shadow-md"
        />
      ) : (
        <div className="flex h-40 w-full flex-col items-center justify-center gap-1 rounded-md bg-neutral-secondary-mid/10 text-neutral-secondary-mid shadow-md">
          <Photos className="h-6 w-6" />
          <span className="px-2 text-center text-xs">
            Voorbeeld niet beschikbaar
          </span>
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        <Chip
          className="gap-1"
          startContent={
            <Tag className="h-3.5 w-3.5 text-neutral-secondary-mid" />
          }
          classNames={{
            base: "h-fit bg-white px-2 border border-neutral-secondary-mid text-neutral-secondary-mid",
            content: "px-0 font-medium",
          }}
        >
          {photo.label}
        </Chip>
        <Chip
          className="gap-1"
          startContent={
            <Calendar className="h-3.5 w-3.5 text-neutral-secondary-mid" />
          }
          classNames={{
            base: "h-fit bg-white px-2 border border-neutral-secondary-mid text-neutral-secondary-mid",
            content: "px-0 font-medium",
          }}
        >
          {photo.createdAt?.toLocaleString("nl-NL", {}) &&
            photo.createdAt?.toLocaleString("nl-NL", {}).split("T")[0]}
        </Chip>
      </div>
    </div>
  );
};
